import { Typography } from '@mui/material';
import React from 'react';

import { MOBILE_MAX_CHARACTERS } from './smsSegments';

// How close to the limit a text whose length still varies per guest (variables, translation) gets a warning.
const NEAR_LIMIT_MARGIN = 150;

const count = (n) => n.toLocaleString('en-US');
const LIMIT = count(MOBILE_MAX_CHARACTERS);

/**
 * What Twilio's 1,600-character limit means for the SMS/WhatsApp text being composed. ``length`` comes from
 * ``campaignMobileLength``. An error when no guest would get the text (``sendBlockedReason`` blocks the Send step
 * then); a warning when some guests' texts may run over. ``fix`` says how to shorten it, for the box the notice sits
 * under.
 */
const MobileLengthNotice = ({ length, fix, translated = false }) => {
    if (!length) return null;
    let error = false;
    let message = null;
    if (length.over) {
        error = true;
        const counted = length.withLinks ? 'the opt-out line and attachment links' : 'the opt-out line';
        message = `Too long for SMS and WhatsApp: ${count(length.characters)} characters with ${counted}. `
            + `They take at most ${LIMIT}, so no guest would get this text. ${fix}`;
    } else if (length.hasTemplateLogic && length.characters > MOBILE_MAX_CHARACTERS) {
        message = `Counting every {% if %} branch, this is over the ${LIMIT} characters SMS and WhatsApp take. `
            + 'A guest whose text runs over gets nothing.';
    } else if (length.characters > MOBILE_MAX_CHARACTERS - NEAR_LIMIT_MARGIN && (length.variables > 0 || translated)) {
        const why = [length.variables > 0 ? 'Variables' : null, translated ? 'translation' : null]
            .filter(Boolean).join(' and ');
        message = `Close to the ${LIMIT}-character limit for SMS and WhatsApp. `
            + `${why.charAt(0).toUpperCase()}${why.slice(1)} can make a guest's text longer, `
            + `and a text over ${LIMIT} characters isn't delivered.`;
    }
    if (!message) return null;
    return (
        <Typography
            variant="caption"
            component="p"
            color={error ? 'error.main' : 'warning.main'}
            sx={{ mt: 0.5, mx: 1.75 }}
            data-testid="mobile-length-notice"
        >
            {message}
        </Typography>
    );
};

export default MobileLengthNotice;
